export default "__VITE_ASSET__e74987a4__"